import { render, staticRenderFns } from "./myDonateList.vue?vue&type=template&id=0085773f&scoped=true&"
import script from "./myDonateList.vue?vue&type=script&lang=js&"
export * from "./myDonateList.vue?vue&type=script&lang=js&"
import style0 from "./myDonateList.vue?vue&type=style&index=0&id=0085773f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085773f",
  null
  
)

export default component.exports